import React from "react";

import { useAppSelector } from "../../../../Store/Hooks";
import { DEFAULT_HEALTH_SCORE_THRESHOLDS } from "../../../../Utils/HealthThresholds";
import {
  businessHealthColor,
  businessHealthColorFromFlag,
  businessHealthFlag,
} from "../../../../Utils/Helper/businessHealth";

import "./style.scss";

interface ScoreBubbleProps {
  healthFlag: "R" | "Y" | "G";
  relevanceFlag: "H" | "M" | "L";
  healthScore?: number;
  relevanceScore?: number;
  className?: string;
}

export const ScoreBubble: React.FC<ScoreBubbleProps> = ({
  healthFlag,
  relevanceFlag,
  healthScore,
  relevanceScore,
  className = "",
}) => {
  const bhThresholds = useAppSelector(
    state =>
      state.vendorAdmin.healthScoreThresholds?.business_health ??
      DEFAULT_HEALTH_SCORE_THRESHOLDS.business_health
  );

  const getRelevanceSize = (flag: "H" | "M" | "L"): string => {
    switch (flag) {
      case "H":
        return "32px"; // 100%
      case "M":
        return "16px"; // 50%
      case "L":
        return "8px"; // 25%
      default:
        return "16px";
    }
  };

  // Prefer score + Settings thresholds over stored API flags.
  const derivedFlag =
    healthScore != null && Number.isFinite(healthScore)
      ? businessHealthFlag(healthScore, bhThresholds)
      : null;
  const effectiveFlag = derivedFlag ?? healthFlag;
  const healthColor =
    (healthScore != null && Number.isFinite(healthScore)
      ? businessHealthColor(healthScore, bhThresholds)
      : null) ?? businessHealthColorFromFlag(effectiveFlag);

  const relevanceSize = getRelevanceSize(relevanceFlag);
  const title = `Health: ${effectiveFlag} (${healthScore ?? "N/A"}) • Relevance: ${relevanceFlag} (${relevanceScore ?? "N/A"})`;

  return (
    <div
      className={`bubble-container ${className}`}
      data-health-flag={effectiveFlag}
      data-relevance-flag={relevanceFlag}
      data-health-score={healthScore || ""}
      data-relevance-score={relevanceScore || ""}
      title={title}
    >
      <div className="bubble-outer">
        <div
          className="bubble-inner"
          style={{
            backgroundColor: healthColor,
            width: relevanceSize,
            height: relevanceSize,
          }}
        />
      </div>
    </div>
  );
};
